var render, staticRenderFns
import script from "./ResultPin.vue?vue&type=script&lang=js&"
export * from "./ResultPin.vue?vue&type=script&lang=js&"
import style0 from "./ResultPin.vue?vue&type=style&index=0&id=03c3a070&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports